<template>
  <div class="d-flex flex-column">
    <module-navigation-bar title="Assembly Preparations">
      <template slot="module-nav-logo">
        <img
          v-if="isDaiwaLicense"
          alt=""
          height="40px"
          src="https://www.daiwahousemodular.eu/wp-content/uploads/daiwa_logo.svg"
        />
      </template>
    </module-navigation-bar>
    <div
      v-if="assemblyPreparationsStatus === 'success'"
      class="flex-1 d-flex overflow-hidden"
    >
      <transition mode="out-in" name="simple-fade">
        <div v-if="!selectedModule" class="d-flex flex-column flex-1 overflow-hidden">
          <dhme-assembly-preparations-grid
            :modules="assemblyPreparationsModules"
            :locations="assemblyPreparationsHallLocations"
            :status-map="statusMap"
            :selected-module="selectedModule"
            :tasks-loaded="tasksLoaded"
            @select-module="selectModule"
          />
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                color="primary"
                fab
                :disabled="!tasksLoaded"
                :loading="!tasksLoaded"
                style="right: 50px; bottom: 100px; position: absolute"
                @click="planBatchDialog = true"
                v-on="on"
              >
                <v-icon dense>mdi-package-variant-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ tasksLoaded ? 'Plan batch' : 'Loading tasks...' }}</span>
          </v-tooltip>
          <dhme-assembly-preparations-batch-dialog
            :displayed="planBatchDialog"
            @batchPlanned="planBatchDialog = false"
            @closeDialog="planBatchDialog = false"
          />
        </div>
        <dhme-assembly-preparations-module-details
          v-else
          :module="selectedModule"
          @closeView="deselectModule"
        />
      </transition>
    </div>
    <div v-else class="d-flex align-center justify-center flex-1">
      <ant-loading />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleNavigationBar from '@/components/Modules/ModuleNavigationBar.vue';
import AntLoading from '@/components/AntLoading.vue';
import DhmeAssemblyPreparationsModuleDetails from '@/modules/daiwa-house-modular-europe/AssemblyPreparations/DhmeAssemblyPreparationsModuleDetails.vue';
import DhmeAssemblyPreparationsBatchDialog from '@/modules/daiwa-house-modular-europe/AssemblyPreparations/DhmeAssemblyPreparationsBatchDialog.vue';
import DhmeAssemblyPreparationsGrid from '@/modules/daiwa-house-modular-europe/AssemblyPreparations/DhmeAssemblyPreparationsGrid.vue';

export default {
  name: 'DhmeAssemblyPreparations',
  components: {
    DhmeAssemblyPreparationsGrid,
    DhmeAssemblyPreparationsBatchDialog,
    DhmeAssemblyPreparationsModuleDetails,
    AntLoading,
    ModuleNavigationBar,
  },
  data: () => ({
    selectedModule: null,
    planBatchDialog: false,
    tasksLoaded: false,
  }),
  computed: {
    ...mapGetters([
      'project',
      'assemblyPreparationsModules',
      'assemblyPreparationsHall',
      'assemblyPreparationsHallLocations',
      'assemblyPreparationsStatus',
      'assemblyPreparationsLocationStatuses',
      'isDaiwaLicense',
    ]),
    statusMap() {
      const map = new Map();
      for (const s of this.assemblyPreparationsLocationStatuses) {
        map.set(`${s.module_id}::${s.assembly_location}`, s);
      }
      return map;
    },
  },
  watch: {
    assemblyPreparationsStatus(status) {
      if (status === 'success') {
        this.$store
          .dispatch('fetchAssemblyPreparationsModuleAssemblyTasks', {
            projectId: this.project.id,
          })
          .then(() => {
            this.tasksLoaded = true;
          });
      }
    },
  },
  async mounted() {
    await this.$store.dispatch(
      'fetchAssemblyPreparationsProjectAssemblyPhase',
      {
        projectId: this.project.id,
      }
    );
  },
  methods: {
    deselectModule() {
      this.selectedModule = null;
    },
    selectModule(module) {
      if (this.selectedModule === module) {
        this.selectedModule = null;
      } else if (this.selectedModule !== null) {
        this.selectedModule = null;
        this.$nextTick(() => {
          this.selectedModule = module;
        });
      } else {
        this.selectedModule = module;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.assembly-preparation-module-item {
  transition: 200ms ease-out;
  cursor: pointer;

  &.active {
    background: #f2f2f2;
    border-left: solid 2px var(--v-primary-base);
  }

  &:hover:not(.disabled) {
    background: #f2f2f2;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
